import { render } from "./DbaForm.vue?vue&type=template&id=26395905"
import script from "./DbaForm.vue?vue&type=script&lang=js"
export * from "./DbaForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__